import { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { BaseProps } from '../../common/BaseProps';
import { getQuantidadeMensagensNaoLidas, getQuantidadeMensagensNaoLidasIdPositiva, getQuantidadeMensagensNaoLidasRL, limpar, selectLastApiCallTime, selectQuantidadeMensagensNaoLidas, setLastApiCallTime } from '../../features/CaixaMensagem/CaixaMensagemSlice';
import { selectPerfilCompleto, selectSelecionouSolicitacaoCadastramento } from '../../features/Perfil/perfilSlice';
import styles from './UserNavBar.module.css';
import auth from '../../auth/Auth';
import { TipoPerfil } from '../../model/TipoPerfil';
import authIdPositiva from '../../auth/AuthIdPositiva';
import moment from 'moment';
import configuration from '../../envConfig';
import { obterNomeDoPerfilComum } from '../../common/perfilUtils';

interface Props extends BaseProps {
  fixed?: boolean;
  name?: string;
  logout?: any;
  caixaMensagens?: any;
}

const UserNavBar: React.FC<Props> = (props) => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const perfil = useAppSelector(selectPerfilCompleto);
  const quantidadeMensagensNaoLidas = useAppSelector(selectQuantidadeMensagensNaoLidas);
  const lastApiCallTime = useAppSelector(selectLastApiCallTime);

  const selecionouSolicitacaoCadastramento = useAppSelector(selectSelecionouSolicitacaoCadastramento);

  const DEFAULT_TIMEOUT_API_LAST_CALL = 300;

  useEffect(() => {
    if (perfil) {
      if (!lastApiCallTime || moment().diff(lastApiCallTime, 'seconds') >= DEFAULT_TIMEOUT_API_LAST_CALL) {
        dispatch(setLastApiCallTime(moment()));

        if (auth.isAuthenticated()) {
          // Caso o usuário seja um representante legal, não precisa consultar a quantidad de mensagens não lidas
          // ALM - Defeito 402284
          let perfilRepresentanteLegal = perfil?.tipoPerfil?.codigo === TipoPerfil.REPRESENTANTE_LEGAL;
          if (perfilRepresentanteLegal) {
            dispatch(getQuantidadeMensagensNaoLidasRL(perfil.identificador));
          } else{
            dispatch(getQuantidadeMensagensNaoLidas(perfil.identificador));
          }
        } else if (authIdPositiva.isAuthenticated()) {
          dispatch(getQuantidadeMensagensNaoLidasIdPositiva(authIdPositiva.getUserId()));
        }
      }
    } else {
        dispatch(limpar());
    }
  }, [dispatch, perfil]);

  const mostrarPerfil = () => {
     history.push('/perfil');
  };

  return (
    <div className={`${styles.container} ${props.fixed ? styles.fixed : ''}`}>
      <div className={configuration.isCordova ? styles.innerContainerMobile : styles.innerContainer}>
        {configuration.isCordova &&
          (<div className={styles.homeIcon}>
            <Link to="/home" >
              <div className={styles.menuItem}>
                <i className={`${styles.icon} fas fa-home`} />
              </div>
            </Link>
          </div>)
        }
        <div className={configuration.isCordova ? styles.userMobile : styles.user} onClick={() => mostrarPerfil()}>
          <i className={`${styles.icon} fa fa-user-circle`} />
            <span>{props.name && (
                <>
                  Olá, <strong>{!!perfil ? obterNomeDoPerfilComum(perfil) : props.name}</strong>
                </>
              )}
            </span>
        </div>
        <div className={configuration.isCordova ? styles.rightIconsWrapperMobile : styles.rightIconsWrapper}>
          {props.logout && (
            <div className={styles.notificationWrapper}>
              <i className={`${styles.notificationIcon} fas fa-envelope`} onClick={() => props.caixaMensagens()} />
              {!selecionouSolicitacaoCadastramento && quantidadeMensagensNaoLidas > 0 && quantidadeMensagensNaoLidas < 100 && (
                <div className={styles.notificationCount}>{quantidadeMensagensNaoLidas}</div>
              )}
              {!selecionouSolicitacaoCadastramento && quantidadeMensagensNaoLidas >= 100 && (
                <div className={styles.notificationCount}>99+</div>
              )}
            </div>
          )}
          {props.logout && (
            <i className={`${styles.logoutIcon} fas fa-sign-out-alt`} onClick={() => props.logout()} />
          )}
        </div>
      </div>
    </div>
  );
};

export default UserNavBar;
